// https://www.docs.developers.amplitude.com/session-replay/sdks/plugin/#mask-on-screen-data
// TL:DR -- Masking is for text elements, blocking is for anything else - boxes, video, images, etc */}
export const PII_MASK_CLASS = 'amp-mask';
export const PII_BLOCK_CLASS = 'amp-block';
